<template>
    <div>
        <v-layout row wrap align-center>
            <v-flex xs12 md6>
                <v-btn to="/StatisticalInformation" color="white">
                    <v-icon dark left>arrow_back</v-icon>Back to Facts, Figures and Timelines
                </v-btn>
            </v-flex>
        </v-layout>
        <v-layout row wrap pt-3 pb-4 align-center>
            <v-flex v-if="containedInCol" xs12>
                <h1>{{ title }}</h1>
            </v-flex>
            <v-flex v-else xs12 md6>
                <h1>{{ title }}</h1>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
    export default {
        props: ['title', 'containedInCol']
    }
</script>